// extracted by mini-css-extract-plugin
export var cartContainer = "_oo-4";
export var gray = "_oo-1";
export var itemContainer = "_oo-2";
export var itemDetails = "_oo-3";
export var strong = "_oo-0";